<template>
  <b-message
    v-if="timezone != $laravel.user.timezone"
    type="is-warning"
    has-icon
  >
    <p v-html="$t('timezone_warning_description', {timezone: timezoneText})" />
  </b-message>
</template>

<script>
export default {
  props: {
    timezone: {
      required: true,
      type: String
    }
  },
  computed: {
    timezoneText () {
      return this.timezone + " " + this.$luxon.now().setZone(this.timezone).toFormat("ZZ");
    }
  }
};
</script>
